import { JOB_ENDPOINTS } from "../config/constants";

export const getJobs = async (token, startDate, endDate, jobId = null) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Job/GetJob`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        JobId: jobId ? parseInt(jobId) : null,
        StartDate: startDate,
        EndDate: endDate,
      }),
    });

      //console.log('Respuesta del servidor:', data); 
    const result = await response.json();
    console.error("result.data:", result);
    if (result.success === 1 && Array.isArray(result.data)) {
      return result.data;
    }

    return [];
  } catch (error) {
    console.error("Error obteniendo jobs:", error);
    return [];
  }
};


export const saveJob = async (token, jobData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Job/SaveJob`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(jobData),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("❌ Error al guardar Job:", error);
    return { success: 0, message: "Error de conexión con el servidor." };
  }
};

export const createJob = async (token, jobData) => {
  try {
    const response = await fetch(JOB_ENDPOINTS.CREATE_JOB, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(jobData),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("❌ Error al crear Job:", error);
    return { success: 0, message: "Error al conectar con el servidor." };
  }
};
